import React from "react";
import Logo from "./Logo";
import { BRAND, NAV_LINKS, PRODUCTS } from "../data/copperx";
import { MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0a0a0b] text-[#94A3B8] pt-20 pb-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-white/10">
          <div className="md:col-span-5">
            <Logo variant="light" />
            <p className="text-[#94A3B8] text-base leading-relaxed mt-6 max-w-md">
              <span className="text-[#E19672]">{BRAND.tagline}.</span> Premium HVAC copper
              tubing, pancake coils, level wound coils, straight tube, and aluminium
              finstock — supplied across the Middle East, Africa &amp; Asia from Dubai, UAE.
            </p>
            <div className="space-y-3 mt-8 text-sm">
              <a href={`tel:${BRAND.phoneHref}`} className="flex items-center gap-3 hover:text-white transition-colors" data-testid="footer-phone">
                <Phone size={14} className="text-[#B85C38]" /> {BRAND.phone}
              </a>
              <a href={`mailto:${BRAND.email}`} className="flex items-center gap-3 hover:text-white transition-colors" data-testid="footer-email">
                <Mail size={14} className="text-[#B85C38]" /> {BRAND.email}
              </a>
              <div className="flex items-center gap-3" data-testid="footer-address">
                <MapPin size={14} className="text-[#B85C38]" /> {BRAND.address}
              </div>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs tracking-[0.3em] uppercase text-white font-semibold mb-5">
              Navigate
            </div>
            <ul className="space-y-3 text-sm">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="hover:text-[#E19672] transition-colors" data-testid={`footer-nav-${l.label.toLowerCase()}`}>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs tracking-[0.3em] uppercase text-white font-semibold mb-5">
              Product Catalogue
            </div>
            <ul className="space-y-3 text-sm">
              {PRODUCTS.map((p) => (
                <li key={p.id}>
                  <a href="#products" className="hover:text-[#E19672] transition-colors" data-testid={`footer-product-${p.id}`}>
                    {p.name}
                  </a>
                </li>
              ))}
              <li>
                <a href="#standards" className="hover:text-[#E19672] transition-colors" data-testid="footer-standards-link">
                  ASTM B280 / B743 Standards
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 pt-8 text-xs font-mono">
          <div>© {new Date().getFullYear()} SSR CopperX Trading LLC. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <span>Dubai · UAE</span>
            <span className="text-[#B85C38]">●</span>
            <span>Efficiency driven, Excellence delivered.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
